// Mirror of backend config/pages.js. Each entry maps a permission key to its
// route path (relative to /workspace/:uuid/) and a human label for the Team
// permission checklist.
export const PAGES = [
  { key: 'dashboard',     label: 'Dashboard',     path: 'dashboard' },
  { key: 'chats',         label: 'Chats',         path: 'chats' },
  { key: 'notifications', label: 'Notifications', path: 'notifications' },
  { key: 'tickets',       label: 'Tickets',       path: 'tickets' },
  { key: 'templates',     label: 'Templates',     path: 'templates/whatsapp' },
  { key: 'automations',   label: 'Automations',   path: 'automations' },
  { key: 'integrations',  label: 'Integrations',  path: 'integrations' },
  { key: 'orders',        label: 'Orders',        path: 'orders' },
  { key: 'wip_orders',    label: 'WIP · Order Tracking', path: 'orders' },
  { key: 'wip_production', label: 'WIP · Production',    path: 'orders' },
  { key: 'wip_stock',     label: 'WIP · Live Stock',    path: 'orders' },
  { key: 'campaigns',     label: 'Campaigns',     path: 'campaigns' },
  { key: 'team',          label: 'Team',          path: 'users' },
];

export const PAGE_KEYS = PAGES.map(p => p.key);
export const pageByKey = (key) => PAGES.find(p => p.key === key);
